export default function FlyweightPage() {
  return (
    <ul>
      <li>Flyweight: </li>
    </ul>
  );
}
